import { Box, Grid, Typography } from '@mui/material';
import GlobalSearcher from 'lib/common/GlobalSearcher';
import { DateInput } from 'lib/common/Inputs/DateInput';
import { SelectInput } from 'lib/common/Inputs/SelectInput';
import CustomButton from 'lib/designSystem/Button';
import TableCard from 'lib/designSystem/Card/TableCard';
import React from 'react';

type GlobalSearcherFilters = React.ComponentProps<
  typeof GlobalSearcher
>['filters'];

type BankOption = {
  value: string;
  label: string;
};

type BankReconciliationSearchPanelProps = {
  searchStartDate: string | null;
  searchEndDate: string | null;
  searchSelectedBankId: string;
  bankOptions: BankOption[];
  globalSearcherFilters: GlobalSearcherFilters;
  periodLabel: string;
  selectedBankLabel: string;
  isSaving: boolean;
  hasDirtyRows: boolean;
  onStartDateChange: (value: string | null) => void;
  onEndDateChange: (value: string | null) => void;
  onSelectedBankChange: (value: string) => void;
  onMinimumSearch: () => void;
  onAdvancedSearch: () => void | Promise<void>;
  onSave: () => void;
};

const BankReconciliationSearchPanel: React.FC<
  BankReconciliationSearchPanelProps
> = ({
  searchStartDate,
  searchEndDate,
  searchSelectedBankId,
  bankOptions,
  globalSearcherFilters,
  periodLabel,
  selectedBankLabel,
  isSaving,
  hasDirtyRows,
  onStartDateChange,
  onEndDateChange,
  onSelectedBankChange,
  onMinimumSearch,
  onAdvancedSearch,
  onSave,
}) => (
  <TableCard sx={{ mb: 2, p: 2 }}>
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={12} md={4}>
        <DateInput
          label="Fecha inicio"
          value={searchStartDate ?? ''}
          onChange={(value) => onStartDateChange(value || null)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DateInput
          label="Fecha término"
          value={searchEndDate ?? ''}
          onChange={(value) => onEndDateChange(value || null)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectInput
          label="Banco"
          value={searchSelectedBankId || null}
          onChange={(value) => onSelectedBankChange(value ?? '')}
          options={bankOptions}
          placeholder="Selecciona un banco"
        />
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', md: 'flex-end' },
            flexWrap: 'wrap',
            gap: 1,
          }}
        >
          <CustomButton color="primary" onClick={onMinimumSearch}>
            Consultar
          </CustomButton>
          <GlobalSearcher
            filters={globalSearcherFilters}
            triggerSearch={async () => {
              await Promise.resolve(onAdvancedSearch());
            }}
            showActionButtons
          />
          <CustomButton
            color="success"
            onClick={onSave}
            disabled={!hasDirtyRows || isSaving}
            loading={isSaving}
          >
            Guardar
          </CustomButton>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
          <Typography variant="caption" color="text.secondary">
            {periodLabel}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {`Banco: ${selectedBankLabel}`}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </TableCard>
);

export default BankReconciliationSearchPanel;
